export const environment = {
  production: false,
  environmentName: 'test',
  apiUrl: 'https://app-trenios-test.azurewebsites.net/api',
  apiTimeout: 30000,
  enableDebugTools: true,
  logLevel: 'info'
};
